<router-outlet></router-outlet>

<ui-loader></ui-loader>
